import writeXlsxFile from "write-excel-file";
// moment
import moment from "moment";
import { getOnline } from "../../../../../utils/services/dashboardSuperScreen";
// helpers
import { parseFirestoreDate } from "../../../../../utils/helpers/files/formatDate";

// formata a data do acesso para "DD/MM/AAAA - HH:mm"
function formatDate(date) {
  const parsedDate = parseFirestoreDate(date);
  if (!parsedDate) return "";

  return moment(parsedDate).format("DD/MM/YYYY - HH:mm");
}

export async function createXlsx({
  eventId,
  transmissionID,
  limit,
  offset,
  search,
  setFinishExport,
  countData,
  mobileapps,
}) {
  const schema = [
    {
      column: "ID do Participante",
      type: String,
      value: (online) => online.id,
    },
    {
      column: "Nome do Participante",
      type: String,
      value: (online) => online.name,
    },
    {
      column: "Data e Hora",
      type: String,
      value: (online) => formatDate(online.date),
    },
  ];

  const allRequestsPromises = [];
  const numberOfRequisitions = Math.ceil(countData / limit);

  for (let i = 1; i <= numberOfRequisitions; i += 1) {
    const request = await getOnline({
      eventId,
      transmissionID,
      pageSize: limit,
      offset: i - 1,
      search,
      mobileapps,
    });

    allRequestsPromises.push(request);
    setTimeout(() => {}, 500);

    const progressBar = document.querySelector(".export-progress");
    const percentageBar = document.querySelector(".export-percentage");

    progressBar.style.width = `${(i / numberOfRequisitions) * 100}%`;
    percentageBar.innerHTML = `${((i / numberOfRequisitions) * 100).toFixed(
      0
    )}%`;

    if (i === numberOfRequisitions) {
      setTimeout(() => {
        setFinishExport(true);
      }, 1000);
    }
  }

  const allDataInSingleArray = allRequestsPromises.map((e) => e.data).flat();
  if (allDataInSingleArray) {
    await writeXlsxFile(allDataInSingleArray, {
      schema,
      fileName: "ParticipantesOnline.xlsx",
    });
  }
}
